import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import fileFinityLogo from '@/assets/filefinity-logo.png';
import { Button } from '../ui/button';

function CarouselHeader({ disabled }: { disabled: boolean }) {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between max-sm:p-[12px] max-md:p-[22px] p-[44px] w-full items-center">
      <Button variant="link" onClick={() => navigate('/')} disabled={disabled}>
        <div className="flex items-center justify-center gap-1">
          <img src={fileFinityLogo} className="h-6" alt="filefinity logo" />
          <h1 className="font-primary font-semibold text-xl">Filefinity</h1>
        </div>
      </Button>
      <Button variant="link" onClick={() => navigate('/')} disabled={disabled}>
        <div className="p-3 bg-[#D9D9D9] hover:bg-[#F4F4F4] rounded-full">
          <X className="h-2.5 w-2.5 " />
        </div>
      </Button>
    </div>
  );
}

export default CarouselHeader;
